import { render, staticRenderFns } from "./itemManager.vue?vue&type=template&id=19d786ff&"
import script from "./itemManager.vue?vue&type=script&lang=js&"
export * from "./itemManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports